module.exports = __webpack_public_path__ + "static/index/img/baikal-202.0bcd18a9.jpg";